import { Field, ObjectType, ID, Float, InputType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { Vendor } from '../vendor/Vendor'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ProductVendorInput')
export class ProductVendor {
  @Field(() => ID)
  @Prop({ type: String, default: () => generateEntityId('pven') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  vendorCode: string

  @Field(() => Float)
  @Prop({ type: Number })
  price: number

  /**
   * Embedded snapshot of the linked vendor user. At write time only
   * `{ _id, company: { _id } }` is supplied (issue #1172) — every other
   * `Vendor`/`User` field is optional, so the embed stores just those two
   * paths. The full `Vendor` (profile, status, full company) is populated at
   * GraphQL query time by `ProductVendorsResolver`.
   */
  @Field(() => Vendor)
  @Prop({ type: Vendor })
  vendor: Vendor

  @Field(() => String)
  @Prop({ type: String })
  remarks: string

  @Field(() => String)
  @Prop({ type: String })
  url: string

  //We just need for types
  vendors: ProductVendor[]
}
